/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 导入修改仓位状态 的 **请求配置**
 *
 * @分类 仓储API/仓位
 * @请求头 `POST /erp/ShippingSpace/batchImportUpdateSpace`
 */
const postBatchImportUpdateSpaceRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/ShippingSpace/batchImportUpdateSpace",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBatchImportUpdateSpace",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入修改仓位状态 的 **请求函数**
 *
 * @分类 仓储API/仓位
 * @请求头 `POST /erp/ShippingSpace/batchImportUpdateSpace`
 */
export const postBatchImportUpdateSpace = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postBatchImportUpdateSpaceRequestConfig, requestData),
    ...args
  );
};
postBatchImportUpdateSpace.requestConfig =
  postBatchImportUpdateSpaceRequestConfig;
/**
 * 接口 绑定仓位,商品分类,囤货量 的 **请求配置**
 *
 * @分类 仓储API/仓位
 * @请求头 `POST /erp/ShippingSpace/band`
 */
const postBandRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/ShippingSpace/band",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBand",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 绑定仓位,商品分类,囤货量 的 **请求函数**
 *
 * @分类 仓储API/仓位
 * @请求头 `POST /erp/ShippingSpace/band`
 */
export const postBand = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postBandRequestConfig, requestData), ...args);
};
postBand.requestConfig = postBandRequestConfig;
/**
 * 接口 编辑仓位前获取仓位信息 的 **请求配置**
 *
 * @分类 仓储API/仓位
 * @请求头 `POST /erp/ShippingSpace/beforeEdit`
 */
const postBeforeEditRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/ShippingSpace/beforeEdit",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBeforeEdit",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 编辑仓位前获取仓位信息 的 **请求函数**
 *
 * @分类 仓储API/仓位
 * @请求头 `POST /erp/ShippingSpace/beforeEdit`
 */
export const postBeforeEdit = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postBeforeEditRequestConfig, requestData), ...args);
};
postBeforeEdit.requestConfig = postBeforeEditRequestConfig;
/**
 * 接口 仓位列表 - 筛选项 的 **请求配置**
 *
 * @分类 仓储API/仓位
 * @请求头 `GET /erp/ShippingSpace/optionsForSpaceList`
 */
const getOptionsForSpaceListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/ShippingSpace/optionsForSpaceList",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getOptionsForSpaceList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 仓位列表 - 筛选项 的 **请求函数**
 *
 * @分类 仓储API/仓位
 * @请求头 `GET /erp/ShippingSpace/optionsForSpaceList`
 */
export const getOptionsForSpaceList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getOptionsForSpaceListRequestConfig, requestData),
    ...args
  );
};
getOptionsForSpaceList.requestConfig = getOptionsForSpaceListRequestConfig;
/**
 * 接口 仓位列表 的 **请求配置**
 *
 * @分类 仓储API/仓位
 * @请求头 `POST /erp/ShippingSpace/spaceList`
 */
const postSpaceListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/ShippingSpace/spaceList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSpaceList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 仓位列表 的 **请求函数**
 *
 * @分类 仓储API/仓位
 * @请求头 `POST /erp/ShippingSpace/spaceList`
 */
export const postSpaceList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postSpaceListRequestConfig, requestData), ...args);
};
postSpaceList.requestConfig = postSpaceListRequestConfig;
/**
 * 接口 新建仓位 的 **请求配置**
 *
 * @分类 仓储API/仓位
 * @请求头 `POST /erp/ShippingSpace/add`
 */
const postAddRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/ShippingSpace/add",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postAdd",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 新建仓位 的 **请求函数**
 *
 * @分类 仓储API/仓位
 * @请求头 `POST /erp/ShippingSpace/add`
 */
export const postAdd = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postAddRequestConfig, requestData), ...args);
};
postAdd.requestConfig = postAddRequestConfig;
/**
 * 接口 导入添加仓位 的 **请求配置**
 *
 * @分类 仓储API/仓位
 * @请求头 `GET /erp/ShippingSpace/batchImportAddSpace`
 */
const getBatchImportAddSpaceRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/ShippingSpace/batchImportAddSpace",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getBatchImportAddSpace",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入添加仓位 的 **请求函数**
 *
 * @分类 仓储API/仓位
 * @请求头 `GET /erp/ShippingSpace/batchImportAddSpace`
 */
export const getBatchImportAddSpace = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getBatchImportAddSpaceRequestConfig, requestData),
    ...args
  );
};
getBatchImportAddSpace.requestConfig = getBatchImportAddSpaceRequestConfig;
/**
 * 接口 批量清空囤货仓位 的 **请求配置**
 *
 * @分类 仓储API/仓位
 * @请求头 `POST /erp/ShippingSpace/clearStockSpaceData`
 */
const postClearStockSpaceDataRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/ShippingSpace/clearStockSpaceData",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postClearStockSpaceData",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量清空囤货仓位 的 **请求函数**
 *
 * @分类 仓储API/仓位
 * @请求头 `POST /erp/ShippingSpace/clearStockSpaceData`
 */
export const postClearStockSpaceData = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postClearStockSpaceDataRequestConfig, requestData),
    ...args
  );
};
postClearStockSpaceData.requestConfig = postClearStockSpaceDataRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/shippingSpace.js